import { render, staticRenderFns } from "./SecondTeacher.vue?vue&type=template&id=26e580e2&scoped=true&"
import script from "./SecondTeacher.vue?vue&type=script&lang=js&"
export * from "./SecondTeacher.vue?vue&type=script&lang=js&"
import style0 from "./SecondTeacher.vue?vue&type=style&index=0&id=26e580e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e580e2",
  null
  
)

export default component.exports